import { render, staticRenderFns } from "./Form.LIs.vue?vue&type=template&id=04c467b4&scoped=true"
import script from "./Form.LIs.vue?vue&type=script&lang=js"
export * from "./Form.LIs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c467b4",
  null
  
)

export default component.exports